import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class DetermineElementVisibilityService {

  footerVisibility(url: string) {
    const pathsWithoutFooter = [
      "/week-planning",
      "/planning",
      "/multi-day-compact",
    ];

    return !pathsWithoutFooter.includes(url);
  }
}
